import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { paymentsActionTypes } from '../payments-action-types';
import { getFormattedDate } from '../../../utils/utilities';
import { getFormattedPaymentReportFormFields } from '../../../constants/payment-report/payment-report-form';
import { errorHandler } from '../../../utils/newApplicationUtils';

export const fetchPaymentReportTypesList = async (dispatch): Promise<void> => {
  dispatch({ type: paymentsActionTypes.START_PAYMENT_REPORT_TYPES_LIST_LOADING });
  try {
    const res = await axios.get(`${BASE_URL.PAYMENTS}/reporting/getLookups`);
    let availableReports = {};
    if (res?.data) {
      availableReports = Object.entries(res?.data?.availableReports || {})?.map(el => ({
        value: el?.[0],
        label: el?.[1]
      }));
    }
    dispatch({ type: paymentsActionTypes.FETCH_PAYMENT_REPORT_TYPES_LIST, payload: availableReports });
  } catch (e) {
    console.log('fetchPaymentReportTypesList error', e);
    dispatch({ type: paymentsActionTypes.FETCH_LOADING_FAIL });
  }
};

export const setPaymentReport = async (dispatch, formik, successModalOpen): Promise<void> => {
  dispatch({ type: paymentsActionTypes.START_SET_PAYMENT_REPORT_LOADING });
  try {
    if (!formik.isValid) return;

    const data = getFormattedPaymentReportFormFields(formik.values);
    const from = data.from ? getFormattedDate(data.from, 'yyyy-MM-dd HH:mm:ss') : '';
    const to = data.to ? getFormattedDate(data.to, 'yyyy-MM-dd HH:mm:ss') : '';
    const timezone = (data.timezone as string)?.replace('+', '%2b');

    const res = await axios.post(`${BASE_URL.PAYMENTS}/reporting/transactionReport?reportId=${data.reportId}&mid=${data.mid}&from=${from}&to=${to}&timezone=${timezone}`);
    if (res?.data?.result) {
      successModalOpen(res.data.result);
    }
    dispatch({ type: paymentsActionTypes.END_SET_PAYMENT_REPORT_LOADING });
  } catch (e) {
    console.log(e);
    errorHandler({ e, formik });
    dispatch({ type: paymentsActionTypes.FETCH_LOADING_FAIL });
  }

};